import React, { SVGProps } from 'react';

export const BranchStartIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="14"
      height="30"
      viewBox="0 0 14 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        id="Vector 456"
        d="M1 1V21C1 25.4183 4.58172 29 9 29H13"
        stroke="#DDDFE5"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
